import { createAction, props } from '@ngrx/store';

import { Client, Contact } from '@lockton-apps/shared/interfaces';

export enum NorwayProposalActionTypes {
  EditClientClicked = '[Norway Proposal] Edit Client Clicked',
  EditContactClicked = '[Norway Proposal] Edit Contact Clicked',
  EditClientAndContactClicked = '[Norway Proposal] Edit Client And Contact Clicked',
}

export const NorwayProposalActions = {
  editClientClicked: createAction(
    NorwayProposalActionTypes.EditClientClicked,
    props<{ client: Client }>()
  ),
  editContactClicked: createAction(
    NorwayProposalActionTypes.EditContactClicked,
    props<{ contact: Contact }>()
  ),
  editClientAndContactClicked: createAction(
    NorwayProposalActionTypes.EditClientAndContactClicked,
    props<{ contact: Contact; client: Client }>()
  ),
};
